export default __webpack_public_path__ + "static/media/logo.3fcaa714.png";